import React, { useEffect, useState, useRef, useCallback } from 'react';
import strings from '../../strings/strings.json'
import { Button, Checkbox, Popconfirm, Spin, Switch, Table } from 'antd'
import { getAvList, setAvActive, setAvDeActive, startUpdateAv, stopAvUpdate, updateAvStatus } from 'api/api_service';
import { IAntiviruses } from 'types';
import moment from 'moment-jalaali';
import ProgressWithLabel from 'components/progress_with_label';
import { antiNameHandler } from 'module/anti_name_handler';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ColumnsType } from 'antd/lib/table';
import { useDropzone } from 'react-dropzone';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { showSnackbar } from 'state/actions';

export default function General() {

  const [avList, setAvList] = useState<Array<IAntiviruses>>([])
  const mountedRef = useRef(true)
  let id: any = null
  let resumeId: any = null
  let intervalId: any = null
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    getAVListHandler()
    return () => {
      mountedRef.current = false
    }
  }, [])

  const getAVListHandler = () => {
    getAvList()
      .then(res => {
        if (res.status === 200) {
          setAvList(res.data.data)
          setIsLoading(false)
        }
      })
  }
  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles[0].name.includes('.tar.gz')) {
      const currentAvUpdateName = localStorage.getItem('currentAvName')
      resumeIconClicked(currentAvUpdateName, false, acceptedFiles[0])
    } else {
      dispatch(showSnackbar({ "open": true, severity: "warning", msg: 'فایل مورد نظر معتبر نمی‌باشد' }));
    }
  }, [])

  const { getRootProps, getInputProps, open } = useDropzone({ onDrop, noClick: true });

  const updateBtnStyleHandler = (data: any) => {
    let color: string = ''
    if (data.status !== undefined)
      if (data.status === 'finished')
        color = 'border-green-400 text-green-400'
      else if (data.status === 'downloading')
        color = 'border-blue-400 text-blue-400'
      else if (data.status === 'stopped')
        color = 'border-orange-400 text-orange-400'
      else if (data.status === 'error')
        color = 'border-black'
      else
        color = 'border-purple-400 text-purple-400'
    else
      color = 'border-black'

    return color
  }

  const btnTextHandler = (status: string) => {
    switch (status) {
      case 'init':
        return strings.public_init
      case 'already updated':
        return strings.public_alreadyUpdate
      case 'finished':
        return strings.public_finished
      case 'started':
        return strings.public_started
      case 'downloading':
        return strings.public_downloading
      case 'extracting':
        return strings.public_extracting
      case 'stopped':
        return strings.public_stopped
      case 'error':
        return strings.public_error

      default:
        break;
    }
  }

  const spinHandler = (data: any) => {
    if (data.status !== undefined) {
      if (data.status === 'finished' || data.status === 'already updated' || data.status === "error") {
        return strings.public_update
      } else {
        return (
          <div className='flex items-center'>
            <img className='ml-2' src={require(`assets/icons/${data.status === 'stop' ? 'stop_av_update' : 'download_av_update'}.svg`)} alt="Icon" />
            <span>{strings.public_updating}</span>
          </div>
        )
      }
    } else {
      return strings.public_update
    }
  }

  const avActiveStatusHandler = (e: any, data: any) => {
    if (e) {
      setAvActive({ "av_name": data.name })
        .then(res => {
          if (res.status === 200) {
            getAVListHandler()
          }
        })
    } else {
      setAvDeActive({ "av_name": data.name })
        .then(res => {
          if (res.status === 200) {
            getAVListHandler()
          }
        })
    }
  }

  const resumeIconClicked = (name: any, is_resume: boolean, file: any) => { // dar inja edameye download anjam mishavad
    setAvList((prevState: any) => {
      return prevState.map((el: any) => {
        if (el.name === name) {
          return {
            ...el,
            isLoading: true
          }
        } else {
          return el
        }
      })
    })
    const formData = new FormData()
    formData.append("resume", JSON.stringify(is_resume))
    if (file)
      formData.append("file", file)

    startUpdateAv({ "av_name": name, "data": formData })
      .then(res => {
        if (res.status === 200) {
          resumeId = setInterval(() => {
            updateAvStatus({ "av_name": name })
              .then(res => {
                if (res.status === 200) {
                  if (res.data.data.status === 'already updated' ||
                    res.data.data.status === 'error' ||
                    res.data.data.status === 'finished' ||
                    res.data.data.status === 'stopped' ||
                    !mountedRef.current) { // payane interval
                    clearInterval(resumeId)
                  }
                  setAvList((prevState: any) => {
                    return prevState.map((el: any) => {
                      if (el.name === name) {
                        return {
                          ...el,
                          status: res.data.data.status,
                          progress: res.data.data.progress,
                          isLoading: false
                        }
                      } else {
                        return el
                      }
                    })
                  })

                }
              })
          }, 5000)
        }

      })
  }

  const stopIconClicked = (data: any) => {
    stopAvUpdate({ "av_name": data.name })
  }

  const stopIconHandler = (data: any) => {
    if (data.status === 'stopped')
      return (
        <Popconfirm
          title={strings.public_resume}
          onConfirm={() => resumeIconClicked(data.name, true, '')}
          onCancel={() => resumeIconClicked(data.name, false, '')}
          okText={strings.public_yes}
          cancelText={strings.public_no}
          icon={''}
        >
          <img title='ادامه' className='ml-2 cursor-pointer' src={require('assets/icons/play_blue.svg').default} alt="Icon" />
        </Popconfirm>
      )
    else if (data.status === 'downloading')
      return (
        <Popconfirm
          title={strings.public_stop}
          onConfirm={() => stopIconClicked(data)}
          okText={strings.public_yes}
          cancelText={strings.public_no}
          icon={''}
          showCancel={false}
        >
          <img title='توقف' className='ml-2 cursor-pointer' src={require('assets/icons/stop_red.svg').default} alt="Icon" />
        </Popconfirm>
      )
  }

  const checkboxOnChange = (e: CheckboxChangeEvent, data: any) => {
    localStorage.setItem('currentAvName', data.name)
    setAvList((prevState: any) => {
      return prevState.map((el: any) => {
        if (el.name === data.name) {
          return {
            ...el,
            is_offline: e.target.checked
          }
        } else {
          return el
        }
      })
    })
  };

  const columns: ColumnsType<any> = [
    {
      title: 'نام',
      dataIndex: 'name',
      key: 'name',
      align: 'right',
      className: 'primary_text_color',
      render: (value, row, index) => (
        <div className='flex items-center'>
          <div><img className='w-6 h-6' src={require(`../../assets/icons/${(row.name !== undefined && antiNameHandler(row.name) !== 'Unknown') ? row.name : 'question'}.png`)} alt="Icon" /></div>
          <div className='flex flex-col mr-2'>
            <span className='primary_text_color text-sm VazirEng'>{antiNameHandler(row.name) === 'Unknown' ? row.name : antiNameHandler(row.name)}</span>
            <span className='text-xs secondry_text_color'><span>{strings.general_lastVersioin}: {row.version ? moment(row.version).format("jYYYY/jMM/jDD") : 'ندارد'}</span></span>
          </div>
        </div>
      ),
    },
    {
      title: 'وضعیت',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      className: 'text-xs',
      render: (value, row, index) => (
        <div className={`flex items-center justify-center relative`}>
          {(row.progress !== undefined && row.progress < 100 && row.progress > 0) && <ProgressWithLabel value={row.progress} />}
          {row.status !== undefined && <span className='ml-4 mr-4 secondry_text_color text-xs'>{btnTextHandler(row.status)}</span>}
          {
            stopIconHandler(row)
          }
          <Popconfirm
            disabled={(row.type !== "vm" && !row.is_offline && (row.status === undefined || row.status === "already updated" || row.status === "finished" || row.status === "error")) ? false : true}
            title={strings.general_resume}
            onConfirm={() => resumeIconClicked(row.name, true, '')}
            onCancel={() => resumeIconClicked(row.name, false, '')}
            okText={strings.general_yes}
            cancelText={strings.general_no}
            icon={''}
          >
            {
              !row.is_offline ?
                <button
                  disabled={(row.type !== "vm" && !row.isLoading || row.status === undefined || row.status === "already updated" || row.status === "finished" || row.status === "error") ? false : true}
                  className={`flex justify-center ml-5 rounded-full border px-8 whitespace-nowrap py-2 text-xs xs:px-6 xs:py-1 xs:ml-2 ${updateBtnStyleHandler(row)} ${row.type === 'vm' ? 'cursor-not-allowed bg-gray-200 text-gray-400 border-gray-400' : ''}`}
                >
                  {
                    (row.isLoading) ?
                      <CircularProgress color="inherit" size={15} />
                      :
                      spinHandler(row)
                  }
                </button>
                :
                <div>
                  {<input {...getInputProps()} />}
                  <button
                    disabled={row.isLoading ? true : false}
                    onClick={() => open()}
                    className={`flex justify-center ml-5 rounded-full border px-8 whitespace-nowrap py-2 text-xs xs:px-6 xs:py-1 xs:ml-2 ${updateBtnStyleHandler(row)}`}
                  >
                    {
                      (row.isLoading) ?
                        <CircularProgress color="inherit" size={15} />
                        :
                        spinHandler(row)
                    }
                  </button>
                </div>
            }
          </Popconfirm >
          {
            (!row.isLoading) &&
            <div className='flex'>
              <Checkbox disabled={row.type === 'vm' ? true : false} onChange={(e) => checkboxOnChange(e, row)}><span className={`${row.type === 'vm' ? 'text-gray-400' : 'primary_text_color'}`}>آفلاین</span></Checkbox>
            </div>
          }
          {/* <div className='absolute left-2 lg:relative md:relative sm:relative xs:relative'>
            {
              row.name === 'yara' &&
              <div className='lg:mr-1 md:mr-1 sm:mr-1 xs:mr-1'>
                <Button className='rounded-2xl py-1 px-2 2xl:px-6 2xl:text-base primary_text_color' type='ghost' onClick={() => navigate('/admin/yara')}>تنظیمات</Button>
              </div>
            }
          </div> */}
        </div>
      ),
    },
    {
      title: 'فعال‌سازی',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      className: 'text-xs',
      render: (value, row, index) => (
        <Switch disabled={row.version ? false : true} checked={row.enabled !== undefined && row.enabled ? true : false} onChange={(e) => avActiveStatusHandler(e, row)} />
      ),
    }
  ]

  return (
    <div className='border border-gray-200 rounded px-5 py-2 mt-10 w-full h-96 overflow-y-scroll'>
      {/*  {avList.length !== 0 && avList.map(mapHandler)} */}
      <Table
        columns={columns}
        dataSource={avList}
        rowClassName='text-sm md:text-base primary_text_color font-bold'
        size='large'
        pagination={false}
        bordered
        loading={isLoading}
        scroll={{ x: 'md' }}
      />
    </div>
  )
}